export enum ButtonSettingsTypeEnum {
    Revise = "revise",
    DigitalWarrant = "digitalWarrant",
}
